import React from "react";
import { classNames } from "../../helpers";
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";

export default function TwListBox({ className = "", options = [], value = "", dropdownArrow = null, onChange, btnClass = "" }) {
  const selected = options.find((d) => d.value === value) || options[0] || null;

  if (!selected || options.length === 0) return null;

  return (
    <Listbox value={selected} onChange={(v) => onChange?.(v)}>
      <Label className="sr-only" />
      <div className="relative">
        <div className={classNames("inline-flex divide-x divide-white rounded-md outline-0 outline-gray-300 [border-0] border-gray-300", btnClass)}>
          <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-transparent px-3 py-2 text-black">
            <span className="text-sm font-semibold">{selected.title}</span>
          </div>
          <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-transparent p-2 outline-none hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-100">
            <span className="sr-only" />
            {dropdownArrow || <ChevronDownIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />}
          </ListboxButton>
        </div>

        <ListboxOptions
          transition
          className="absolute right-0 z-10 mt-2 min-w-32 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
        >
          {options.map((option, idx) => (
            <ListboxOption
              key={option.value ?? idx}
              value={option}
              className="group cursor-default select-none p-4 text-sm text-gray-900 data-[focus]:bg-gray-200 data-[focus]:text-gray-900"
            >
              <div className="flex justify-between">
                <p className="font-normal group-data-[selected]:font-semibold truncate">{option.title}</p>
                <span className="text-gray-900 group-[&:not([data-selected])]:hidden group-data-[focus]:text-gray-900">
                  <CheckIcon aria-hidden="true" className="size-5" />
                </span>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
